ue Copy code
<template>
  <v-dialog v-model="isOpen" persistent :max-width="maxWidth">
    <v-card>
      <v-sheet class="text-h6 px-5 py-2 d-flex align-center">
        {{ title }}
        <v-spacer />
        <v-btn variant="plain" size="x-small" icon="mdi-close" @click="isOpen = false" />
      </v-sheet>

      <v-divider />

      <v-card-text>
        <slot name="message">
          {{ message }}
        </slot>
      </v-card-text>

      <v-card-actions>
        <v-btn
          variant="flat"
          class="text-capitalize"
          color="blue-darken-3"
          @click="priorityToCancel ? cancel() : confirm()"
        >
          {{ priorityToCancel ? cancelText : confirmText }}
        </v-btn>

        <v-btn
          variant="text"
          class="text-capitalize mr-2"
          @click="priorityToCancel ? confirm() : cancel()"
        >
          {{ priorityToCancel ? confirmText : cancelText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  message: {
    type: String,
    default: ''
  },
  confirmText: {
    type: String,
    default: 'Οκ'
  },
  cancelText: {
    type: String,
    default: 'Ακύρωση'
  },
  priorityToCancel: {
    type: Boolean,
    default: false
  },
  maxWidth: {
    type: [String, Number],
    default: '500px'
  }
})

const emit = defineEmits(['update:isOpen', 'confirm', 'cancel'])

const isOpen = defineModel({ required: true })

const confirm = () => {
  emit('confirm')
  isOpen.value = false
}

const cancel = () => {
  emit('cancel')
  isOpen.value = false
}
</script>
